import get from 'lodash/get';

export function getServerErrorText(payload) {
  return (
    get(payload, 'error.meta.validationErrors.attachment[0].code') ||
    'Something went wrong'
  );
}



// WEBPACK FOOTER //
// ./src/utils/ui/getServerErrorText.js